import { useState, useMemo } from "react";

export function useProductFilters(products) {
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [popularFilter, setPopularFilter] = useState(false);
  const [sortBy, setSortBy] = useState("name");

  const filteredProducts = useMemo(() => {
    return products
      .filter((p) => {
        const name = typeof p.name === "string" ? p.name : "";

        const matchesSearch = name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const matchesStatus =
          statusFilter === "all" ||
          (statusFilter === "active" && p.status === "active") ||
          (statusFilter === "disabled" && p.status === "disabled") ||
          (statusFilter === "low-stock" &&
            p.quantity > 0 &&
            p.quantity <= 10) ||
          (statusFilter === "out-of-stock" && p.quantity === 0);
        const matchesCategory =
          categoryFilter === "all" || p.categoryId === categoryFilter;
        const matchesPopular = !popularFilter || p.popular;
        return (
          matchesSearch && matchesStatus && matchesCategory && matchesPopular
        );
      })
      .sort((a, b) => {
        if (sortBy === "name") return a.name.localeCompare(b.name);
        if (sortBy === "date") return b.id - a.id;
        if (sortBy === "price") return b.price - a.price;
        if (sortBy === "quantity") return b.quantity - a.quantity;
        return 0;
      });
  }, [
    products,
    searchQuery,
    statusFilter,
    categoryFilter,
    popularFilter,
    sortBy,
  ]);

  return {
    searchQuery,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    categoryFilter,
    setCategoryFilter,
    popularFilter,
    setPopularFilter,
    sortBy,
    setSortBy,
    filteredProducts,
  };
}
